import React, { useEffect, useState } from "react";
import DataIcon from "../../../assets/img/stm-data.svg";
import CallIcon from "../../../assets/img/stm-call.svg";
import BlueSMSIcon from "../../../assets/img/BlueSMS.png";
import RedDataIcon from "../../../assets/img/RedData.svg";
import RedCallIcon from "../../../assets/img/RedCall.svg";
import RedSMSIcon from "../../../assets/img/RedSMS.svg";
import Translations from "../../../services/translation.service";
import storefront from "../../../services/storefront.service";
import STF_CONSTANTS from "../../../services/stfConstant.service";
import Storage from "../../../services/storage.service";
import User from "../../../services/user.service";
import * as variables from "../../../variables";
import bannerInfinity from "../../../assets/img/blackInfinity.svg";
import overlay from "../../../assets/img/AdjustOverlay.png";
import defaultImage from "../../../assets/img/default_small.png";
import Helpers from "../../../helpers/shared.helper";
import FirebaseAnalytics from "../../../services/analytics.service";
import CONSTANTS from "../../../services/constants.service";

const subscriptions = [];
// let prefix = "stm_1_";
let prefix_general = "stm_general_";
const PlanCardSingleAuto = ({ planDetails, cardType, setLoading = () => {}, eligibilityFailedPostpaid = false }) => {
  const [extraData, setExtraData] = useState("");
  // const [discountedPrice, setDiscountedPrice] = useState(0);
  const [socialDataValue, setSocialDataValue] = useState(null);
  const [onNetMinuteValue, setOnNetMinuteValue] = useState(null);
  const [dataBonusValue, setDataBonusValue] = useState(null);
  const [voiceBonusValue, setVoiceBonusValue] = useState(null);
  const [dataRomBonusValue, setDataRomBonusValue] = useState(null);
  const [voiceIntBonusValue, setVoiceIntBonusValue] = useState(null);
  const [streamingList, setStreamingList] = useState([]);
  const [dataValue, setDataValue] = useState(0);
  const [minValue, setMinValue] = useState(0);
  const [smsValue, setSmsValue] = useState(0);
  const [socialValue, setSocialValue] = useState(0);
  const [dataRomValue, setDataRomValue] = useState(0);
  const [minIntValue, setMinIntValue] = useState(0);
  const [minOnNetValue, setMinOnNetValue] = useState(0);
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );

  useEffect(() => {
    getExtras();
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getExtras = () => {
    const contentService = Helpers.getStreaminService();
    if (
      planDetails?.ExtraDetails &&
      planDetails?.ExtraDetails !== "" &&
      planDetails?.ExtraDetails !== undefined
    ) {
      let details = planDetails?.ExtraDetails
        ? JSON.parse(planDetails?.ExtraDetails)
        : "";

      // if (
      //   details?.DiscountedPrice &&
      //   +details?.DiscountedPrice !== 0 &&
      //   +details?.DiscountedPrice !== details?.OriginalPrice
      // ) {
      //   setDiscountedPrice(+details?.DiscountedPrice);
      // }

      if (details.Promotions.length) {
        const localData = [];
        details.Promotions.forEach((item) => {
          const valueObj = JSON.parse(item?.Value);
          if (
            valueObj?.Type &&
            contentService?.includes(
              valueObj?.Type?.toLowerCase()
            )
          ) {
            localData.push(valueObj?.Type);
          }
        });
        setStreamingList(localData);
      }

      if (Array.isArray(details?.Promotions) && details?.Promotions.length) {
        var addonsValues = storefront.getSumData(
          details?.Promotions,
          variables.PROMOTION_TYPE_DATA_SOCIAL,
          "gb"
        );
        var dataBonusValues = storefront.getSumData(
          details?.Promotions,
          variables.PROMOTION_TYPE_DATA,
          "gb"
        );

        var minutesBonusValues = storefront.getSumData(
          details?.Promotions,
          variables.PROMOTION_TYPE_VOICE_LCL,
          "min"
        );

        var dataRomBonusValues = storefront.getSumData(
            details?.Promotions,
            variables.PROMOTION_TYPE_DATA_ROM,
            "gb"
          );
  
        var minutesIntBonusValues = storefront.getSumData(
            details?.Promotions,
            variables.PROMOTION_TYPE_VOICE_INT,
            "min"
        );

        var onNetMinutesBonusValues = storefront.getSumData(
          details?.Promotions,
          variables.PROMOTION_TYPE_VOICE_ON_NET,
          "min"
        );

        if (onNetMinutesBonusValues) setOnNetMinuteValue(onNetMinutesBonusValues);
        if (addonsValues) setSocialDataValue(addonsValues);
        if (dataBonusValues) setDataBonusValue(dataBonusValues);
        if (dataRomBonusValues) setDataRomBonusValue(dataRomBonusValues);
        if (minutesIntBonusValues) setVoiceIntBonusValue(minutesIntBonusValues);
        if (minutesBonusValues) setVoiceBonusValue(minutesBonusValues);
      }

      let planData = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_DATA
      );

      let planMins = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_VOICE_LCL
      );

      let planDataRom = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_DATA_ROM
      );

      let planIntMins = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_VOICE_INT
      );

      let planOnNetMins = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_VOICE_ON_NET
      );

      let planSms = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_SMS
      );

      let planSocial = details?.Plan.find(
        (item) => item?.Type === variables.PROMOTION_TYPE_DATA_SOCIAL
      );

      if (planData && planData?.Value) {
        const value = getPlanDataMinValue(
          planData.Value,
          STF_CONSTANTS.DATA_TYPE
        );
        setDataValue(value);
      }

      if (planMins && planMins?.Value) {
        const value = getPlanDataMinValue(
          planMins.Value,
          STF_CONSTANTS.MINUTE_TYPE
        );
        setMinValue(value);
      }

      if (planDataRom && planDataRom?.Value) {
        const value = getPlanDataMinValue(
          planDataRom.Value,
          STF_CONSTANTS.DATA_TYPE
        );
        setDataRomValue(value);
      }

      if (planIntMins && planIntMins?.Value) {
        const value = getPlanDataMinValue(
          planIntMins.Value,
          STF_CONSTANTS.MINUTE_TYPE
        );
        setMinIntValue(value);
      }

      if (planOnNetMins && planOnNetMins?.Value) {
        const value = getPlanDataMinValue(
            planOnNetMins.Value,
            STF_CONSTANTS.MINUTE_TYPE
        );
        setMinOnNetValue(value);
      }

      if (planSms && planSms?.Value) {
        const value = getPlanDataMinValue(
          planSms.Value,
          STF_CONSTANTS.SMS_TYPE
        );
        setSmsValue(value);
      }

      if (planSocial && planSocial?.Value) {
        const value = getPlanDataMinValue(
          planSocial.Value,
          STF_CONSTANTS.DATA_TYPE
        );
        setSocialValue(value);
      }

      setExtraData(details);
    }
  };

  const getPlanDataMinValue = (data, type) => {
    let value = storefront.getPlanDataMinValue(data, type);
    return value;
  };

  const totalSocialData = (socialDataValue, socialValue) => {
    let totalsocialData = `${Number(socialDataValue) + Number(socialValue)}`;
    return totalsocialData;
  }

  const selectPlan = () => {
    setLoading(true);
    if (planDetails?.CTA) {
      FirebaseAnalytics.storefront_cta_selected(planDetails?.CTA);
    }
    storefront.selectPlan(cardType, planDetails)
    // let validity = planFG.checkValidity(extraData?.Plan);
    // Storage.set("is_web_category_selected", true, true);

    // Storage.set("pre-defined-plan-selected", extraData?.PlanCode, true);
    // Storage.set("pre-defined-plan-selected-detail", JSON.stringify(extraData), true);
    // Storage.set("pre-defined-plan-selected-validity", validity, true);
    // Storage.set("pre-defined-plan-selected-product-code", planDetails?.ProductCode, true);
    // Storage.set("is_custom_card_selected", false, true);
    // Storage.set("choose_plan_category", true, true);



    // const ActiveProductCodes = planDetails?.ProductCode;
    // const is5g = (cardType === "5G Home broardband plans" || cardType === "5G plans");
    // Storage.set("is_category_type_5g", is5g, true);
    // Storage.set("ActiveProductCodes", ActiveProductCodes, true);
    // User.fetchFlowStatus()
    //   .then((response) => {
    //     setLoading(false);
    //   })
    //   .catch((err) => {
    //     setLoading(false);
    //   });
  };

  const selectPrePaidPlan = () => {
    setLoading(true);
    if (planDetails?.CTA) {
      FirebaseAnalytics.storefront_cta_selected(planDetails?.CTA);
    }
    const ActiveProductCodes = planDetails?.ProductCode;
    Storage.set("pre-defined-plan-selected", extraData?.PlanCode, true);
    Storage.set("pre-defined-plan-selected-detail", JSON.stringify(extraData), true);
    Storage.set("pre-defined-plan-selected-product-code", ActiveProductCodes, true);
    Storage.set("is_custom_card_selected", false, true);
    Storage.set("ActiveProductCodes", ActiveProductCodes, true);

    // Storage.set("tempDisabledPlan", true, true);
    User.updateFlowStatus("postpaid_eligible", false).then(() => {
      User.fetchFlowStatus();
    }).catch(() => {
      setLoading(false);
    });
  };

  // const getBackgroundImage = (planDetails) => {
  //   let url = "";
  //   let defaultUrl = storefront.getPoImage("stf_predefined_img", "default_img");

  //   if (planDetails?.PlanName) {
  //     const newName = planDetails?.PlanName.trim().replace(" ", "");
  //     url = storefront.getPoImage(
  //       "stf_predefined_img",
  //       `category-${newName}-${Translations.getCurrentLanguage()}`
  //     );
  //   }

  //   return url !== "" ? url : defaultUrl;
  // };

  const getBackgroundImage = (plan_name) => {   
    const is5g = (cardType === "5G Home broardband plans" || cardType === "5G plans");
    // const isMobile = Helpers.isMobile()
    // const predefinedImage = `${isMobile ? "mob_" : ""}predefined_${plan_name.toLowerCase()}_${Translations.getCurrentLanguage()}`;
    // const predefinedImage = `predefined_${plan_name.toLowerCase()}`;
    let requiredPlanImage = null;
    let planImagesData = "";
    if(is5g) {
      // stf_predefined_plan_fg_images
      planImagesData = JSON.parse(Storage.get("stf_predefined_img_for_mobile", true));
      const predefinedFgImage = `${plan_name.toLowerCase()}_small_${Translations.getCurrentLanguage()}`;
      requiredPlanImage = planImagesData && planImagesData[predefinedFgImage]?.url;
    } else {
      // stf_predefined_img_for_mobile
      planImagesData = JSON.parse(Storage.get("stf_predefined_img_for_mobile", true));
      const predefinedImage = `${plan_name.toLowerCase()}_small_${Translations.getCurrentLanguage()}`;
      requiredPlanImage = planImagesData && (planImagesData[predefinedImage]?.url || planImagesData[`${plan_name.toLowerCase()}_small`]?.url);
    }
    
    return requiredPlanImage || planImagesData["default_small"]?.url || defaultImage;
  };

  // const getPlanName = (extra_details, plan_name) => {
  //   let plan_prefix = "general_plan_name_";
  //   let parsedExtraDetails = JSON.parse(extra_details);
  //   if(parsedExtraDetails?.PlanCode)
  //   {
  //     return Translations.keys[plan_prefix + parsedExtraDetails.PlanCode] || plan_name;
  //   }
  //   return plan_name
  // };

  const handleAdjustFont = () => {    
    if((dataValue && dataValue !== 0) && (dataRomValue && dataRomValue !== 0) && (minIntValue && minIntValue !== 0) && (minOnNetValue && minOnNetValue !== 0) && (minValue && minValue !== 0) && (smsValue && smsValue !== 0)) {
      return "adjust-font";     
    }
    return "";
  }

  const getDiscount = (type) => {
    let discPercentage = {
      value: 0,
      type: type
    };
    const discPercentageItem = planDetails?.ExtraDetails?.Promotions?.find((item)=> item?.Type === type )
   if(discPercentageItem && discPercentageItem?.Value) {
    const parsedDiscountAmount = JSON.parse(discPercentageItem?.Value);
    let checkJSON = false;
    if(parsedDiscountAmount?.DiscountAmount) {
      checkJSON = true;
    }
    if(checkJSON) {
      // JSON Object in Value
      discPercentage = {
        value: parsedDiscountAmount?.DiscountAmount || 0,
        type: type
      }
    } else {
      // Direct Value in Value
      discPercentage =  {
        value: discPercentageItem?.Value || 0,
        type: type
      }
    }
   }
    return discPercentage
  }

  return (
    <>
      <div
        className="plan-card-single-auto"
        onClick={() => {
          if(eligibilityFailedPostpaid) {
            selectPrePaidPlan();
          } else {
            selectPlan();
          }
        }}
      >
        <div className="plan-card-single-upper">
          <img 
            className="plan-card-single-img"
            src={getBackgroundImage(planDetails?.PlanName)} 
            alt=""
          />
          <img
            className="overlay-image"
            src={overlay}
            alt=""
          />
          <div className="plan-card-single-ribbon">
            {getDiscount(CONSTANTS.PercentDiscount)?.value > 0 && (
              <div className="plan-card-single-ribbon-blue">
                {getDiscount(CONSTANTS.PercentDiscount)?.value}{"% "}{translationKeys["stm_general_currency"]}{" "}{translationKeys["src_plan_card_offer_discount"]}
              </div>
            )}
            {getDiscount(CONSTANTS.AmountDiscount)?.value > 0 && (
              <div className="plan-card-single-ribbon-blue">
                {getDiscount(CONSTANTS.AmountDiscount)?.value}{" "}{translationKeys["stm_general_currency"]}{" "}{translationKeys["src_plan_card_offer_discount"]}
              </div>
            )}
            {/* {discountedPrice ? (
              <div className="plan-card-single-ribbon-blue">
                -{extraData?.DiscountValue + " "}
                {translationKeys[prefix_general + "currency"] + " "}
                {translationKeys[prefix + "discount"] + " "}
              </div>
            ) : null} */}
            {/* {extraData?.Plan && extraData.Plan.length > 0 && extraData?.Plan[0]?.Validity > 0? (
              <div className="plan-card-single-ribbon-red">
                {translationKeys[prefix_general + "Validity"] + " "}
                {extraData?.Plan[0]?.Validity + " "}
                {translationKeys[prefix_general + "days"]}
              </div>
            ) : null} */}
          </div>
          <div className="bottom-section">
            <div className="plan-card-single-sr">
              <div>
                <p
                  className="plan-name"
                  title={translationKeys[`general_plan_name_${Helpers.processPlanCode(planDetails?.ExtraDetails, "ExtraDetails")}`] ?? planDetails?.PlanName}
                >
                  {translationKeys[`general_plan_name_${Helpers.processPlanCode(planDetails?.ExtraDetails, "ExtraDetails")}`] ?? planDetails?.PlanName}
                </p>
              </div>
              <div className="plan-card-single-discounted">
                {extraData.OriginalPrice - extraData?.DiscountedPrice > 0 ? (
                  <>
                    {extraData?.DiscountedPrice}{" "}
                    {" " + translationKeys[prefix_general + "currency"]}
                    <s>
                      {extraData?.OriginalPrice}
                      {" " + translationKeys[prefix_general + "currency"]}
                    </s>
                  </>
                ) : extraData?.OriginalPrice ? (
                  <>
                    {extraData?.OriginalPrice}
                    {" " + translationKeys[prefix_general + "currency"]}
                  </>
                ) : null}
              </div>
            </div>
            {streamingList?.length ? (
              <ul>
                {streamingList.slice(0, 3).map((ele, index) => {
                  return (
                    <li key={"content" + index}>
                      <img
                        key={index}
                        src={storefront.getPoImage(
                          "stf_streaming_img",
                          ele
                        )}
                        alt={ele}
                        className={`${ele.toLowerCase()}-icon`}
                      />
                    </li>
                  );
                })}
              </ul>
            ) : null}
          </div>
        </div>
        <div className="plan-card-single-lower">
          <div
            className={`plan-card-single-detail ${
              socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue
                ? "horizontal"
                : ""
            } ${handleAdjustFont()}`}
          >
            {dataValue && dataValue !== 0 ? (
              <div
                className={`plan-card-vertical ${
                  (socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && !Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode)
                    ? "horizontal"
                    : ""
                }`}
              >
                <img src={Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode) ? RedDataIcon : DataIcon} alt="data" />
                <div>
                  {dataValue < 0 ? (
                    <img src={bannerInfinity} alt="Infinity" />
                  ) : (
                    dataValue
                  )}
                  <span>
                    {" " + translationKeys[prefix_general + "data_unit"]}
                  </span>
                </div>
              </div>
            ) : ""}
            {minValue && minValue !== 0 ? (
              <div
                className={`plan-card-vertical ${
                  (socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && !Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode)
                    ? "horizontal"
                    : ""
                }`}
              >
                <img src={Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode) ? RedCallIcon : CallIcon} alt="Min" />
                <div>
                  {minValue < 0 ? (
                    <img src={bannerInfinity} alt="Infinity" />
                  ) : (
                    minValue
                  )}
                  <span>
                    {" " + translationKeys[prefix_general + "minute_unit"]}
                  </span>
                </div>
              </div>
            ) : ""}
            {minOnNetValue && minOnNetValue !== 0 ? (
              <div
                className={`plan-card-vertical ${
                  (socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && !Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode)
                    ? "horizontal"
                    : ""
                }`}
              >
                <img src={Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode) ? RedCallIcon : CallIcon} alt="Min" />
                <div>
                  {minOnNetValue < 0 ? (
                    <img src={bannerInfinity} alt="Infinity" />
                  ) : (
                    minOnNetValue
                  )}
                  <span>
                    {" " + translationKeys[prefix_general + "minute_unit"]}
                  </span>
                </div>
              </div>
            ) : ""}
            {minIntValue && minIntValue !== 0 ? (
              <div
                className={`plan-card-vertical ${
                  (socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && !Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode)
                    ? "horizontal"
                    : ""
                }`}
              >
                <img src={Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode) ? RedCallIcon : CallIcon} alt="Min" />
                <div>
                  {minIntValue < 0 ? (
                    <img src={bannerInfinity} alt="Infinity" />
                  ) : (
                    minIntValue
                  )}
                  <span>
                    {" " + translationKeys[prefix_general + "minute_unit"]}
                  </span>
                </div>
              </div>
            ) : ""}
            {smsValue && smsValue !== 0 ? (
              <div
                className={`plan-card-vertical ${
                  (socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && !Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode)
                    ? "horizontal"
                    : ""
                }`}
              >
                <img src={Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode) ? RedSMSIcon : BlueSMSIcon} alt="SMS" />
                <div>
                  {smsValue < 0 ? (
                    <img src={bannerInfinity} alt="Infinity" />
                  ) : (
                    smsValue
                  )}
                  <span>
                    {" " + translationKeys[prefix_general + "sms_unit"]}
                  </span>
                </div>
              </div>
            ) : ""}

            {dataRomValue && dataRomValue !== 0 ? (
              <div
                className={`plan-card-vertical ${
                  (socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && !Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode)
                    ? "horizontal"
                    : ""
                }`}
              >
                <img src={Helpers.isPlanPostPaidDynamic(planDetails?.ProductCode) ? RedDataIcon : DataIcon} alt="data" />
                <div>
                  {dataRomValue < 0 ? (
                    <img src={bannerInfinity} alt="Infinity" />
                  ) : (
                    dataRomValue
                  )}
                  <span>
                    {" " + translationKeys[prefix_general + "data_unit"]}
                  </span>
                </div>
              </div>
            ) : ""}
          </div>
          {(socialDataValue || socialValue || voiceBonusValue || voiceIntBonusValue || dataBonusValue || dataRomBonusValue || onNetMinuteValue) && (
            <div 
              className="plan-card-single-offer-auto" 
              style={{
                background: storefront.getPoBgColor(
                  "sf_plan_card_colors",
                  `sf_plan_promotion_bg_color_${planDetails?.ProductCode}`
                ) ?? "#3F5FE0",
                color: storefront.getPoBgColor(
                  "sf_plan_card_colors",
                  `sf_plan_promotion_text_color_${planDetails?.ProductCode}`
                ) ?? "#FFFFFF"
              }}
            >
              {socialDataValue || socialValue ? (
                <span>
                  {translationKeys[prefix_general + "social_data"]}{" "}
                  <strong>{`${
                    socialDataValue === -1 || socialValue === -1
                      ? Translations.keys["free_addons_unlimited"]
                      : totalSocialData(socialDataValue, socialValue)
                  } ${translationKeys[prefix_general + "data_unit"]}`}</strong>
                </span>
              ) : null}
              {dataBonusValue && (
                <span>
                  {translationKeys[prefix_general + "double_data"]}{" "}
                  <strong>{`${
                    dataBonusValue === -1
                      ? Translations.keys["free_addons_unlimited"]
                      : dataBonusValue
                  } ${translationKeys[prefix_general + "data_unit"]}`}</strong>
                </span>
              )}
              {dataRomBonusValue && (
                <span>
                  {translationKeys[prefix_general + "rom_data_card"]}{" "}
                  <strong>{`${
                    dataRomBonusValue === -1
                      ? Translations.keys["free_addons_unlimited"]
                      : dataRomBonusValue
                  } ${translationKeys[prefix_general + "data_unit"]}`}</strong>
                </span>
              )}
              {voiceBonusValue && (
                <span>
                  {translationKeys[prefix_general + "streaming_validity"]}{" "}
                  <strong>{`${
                    voiceBonusValue === -1
                      ? Translations.keys["free_addons_unlimited"]
                      : voiceBonusValue
                  } ${
                    translationKeys[prefix_general + "minute_unit"]
                  }`}</strong>
                </span>
              )}
              {voiceIntBonusValue && (
                <span>
                  {translationKeys[prefix_general + "voice_int_card"]}{" "}
                  <strong>{`${
                    voiceIntBonusValue === -1
                      ? Translations.keys["free_addons_unlimited"]
                      : voiceIntBonusValue
                  } ${
                    translationKeys[prefix_general + "minute_unit"]
                  }`}</strong>
                </span>
              )}
              {onNetMinuteValue && (
                <span>
                  <strong>{`${
                    onNetMinuteValue === -1
                      ? Translations.keys["sf_general_on_net_unlimited"]
                      : onNetMinuteValue
                  } `}</strong>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PlanCardSingleAuto;
